module.exports = __webpack_public_path__ + "img/primary_5x3_z18.5a06c48f.svg";